import { Icon } from "@material-ui/core"
import loff from './logos/loff.png'
                                       
export const Iconl1 = () => (
    <Icon>
        <img src={loff} />
    </Icon>
)